import { createContext, useContext, useEffect, useState } from "react";
import { getAllContentfulData } from "../utils/APIs";

const ContentfulContext = createContext({});

export const ContentfulContextProvider = ({ children }) => {
    const [enums, setEnums] = useState({});
    const [content, setContent] = useState({});
    const [announcements, setAnnouncements] = useState({});

    useEffect(() => {
        const cachedData = JSON.parse(sessionStorage.getItem("contentfulData") || "{}");
        const currentTime = new Date().getTime();
    
        if (cachedData.timestamp && currentTime - cachedData.timestamp < 15 * 60 * 1000) {
            setEnums(cachedData.enums);
            setAnnouncements(cachedData.announcements);
            setContent(cachedData.static_content);
        } else {
            getContentfulData();
        }
    }, []);

    const getContentfulData = async () => {
        try {
            const result = await getAllContentfulData();
            // setContentfulData(result?.data);
            setEnums(result?.data?.enums);
            setAnnouncements({
                release: result?.data?.announcements?.release,
                trial_plan: result?.data?.announcements?.trial_plan,
            });
            setContent(result?.data?.static_content);
    
            sessionStorage.setItem("contentfulData", JSON.stringify({
                ...result.data,
                timestamp: new Date().getTime(),
            }));
        } catch (err) {
            console.log("err", err);
        }
    };

    return (
        <ContentfulContext.Provider value={{ enums, content, announcements }}>
            {children}
        </ContentfulContext.Provider>
    );
};

export const useContentfulContext = () => useContext(ContentfulContext);
